/**
 * Cache Manager utility for clearing all application caches
 * Used primarily when switching organizations to ensure clean data
 */

/**
 * Clears all application caches from localStorage
 * This ensures no stale data persists when switching organizations
 */
export const clearAllAppCaches = (): void => {
  // List of all cache keys used in the application
  const cacheKeys = [
    // GL Accounts
    'finstack_gl_accounts_cache',
    'finstack_gl_accounts_cache_timestamp',
    'finstack_gl_accounts_last_sync',
    
    // Transactions
    'finstack_transactions_cache',
    'finstack_transactions_cache_timestamp',
    'finstack_transactions_last_sync',
    
    // Transaction Rules
    'finstack_transaction_rules_cache',
    'finstack_transaction_rules_cache_timestamp',
    'finstack_transaction_rules_last_sync',
    
    // Plaid
    'finstack_plaid_connections_cache',
    'finstack_plaid_connections_cache_timestamp',
    'finstack_plaid_link_token_cache',
    'finstack_plaid_analytics_cache',
    'finstack_plaid_analytics_cache_timestamp',
    'finstack_plaid_sync_state',
    'finstack_plaid_last_sync_timestamp',
    
    // Import state (for transaction imports)
    'finstack_review_transactions',
    'finstack_show_import_review',
  ];

  // Clear all cache keys
  cacheKeys.forEach(key => {
    localStorage.removeItem(key);
  });

  // Also clear any connection-specific Plaid caches (they have dynamic keys)
  const allKeys = Object.keys(localStorage);
  allKeys.forEach(key => {
    if (key.startsWith('finstack_plaid_connection_status_cache_') ||
        key.startsWith('finstack_plaid_connection_status_cache_timestamp_')) {
      localStorage.removeItem(key);
    }
  });

  console.log('[CacheManager] All application caches cleared');
};